import React from 'react';

/**
 * FlowGate "Open Gate" mark, a G whose opening is the gate, with the flow
 * arrow passing through. Same asset as the landing page (Tideway palette).
 *
 * Set `mono` to render the G stroke in a single color (e.g. white on the
 * indigo sidebar) instead of the teal-to-indigo gradient.
 */
const BrandMark = ({ size = 30, mono = null, gradientId = 'fg-mark-app' }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true">
    {!mono && (
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#0BBBB2" />
          <stop offset="1" stopColor="#4F46E5" />
        </linearGradient>
      </defs>
    )}
    <path
      d="M49.3 42 A20 20 0 1 1 49.3 22"
      stroke={mono || `url(#${gradientId})`}
      strokeWidth="8"
      strokeLinecap="round"
      fill="none"
    />
    <path d="M27 32 H47" stroke="#F8A92B" strokeWidth="7.5" strokeLinecap="round" />
    <path
      d="M40 25 L48 32 L40 39"
      stroke="#F8A92B"
      strokeWidth="7.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export default BrandMark;
